import { FirebaseOptions } from 'firebase/app';

export type EnvironmentKey = 'dev' | 'staging' | 'production';

interface FirebaseEnvironmentConfig extends FirebaseOptions {
  firestoreDatabaseId: string;
  appCheckSiteKey: string;
}

// Dev keys are intentionally committed — dev is a low-risk environment used only locally.
// For staging and production, this file is overwritten at build time by scripts/build-env.js
// using values from the FIREBASE_WEBAPP_CONFIG secret injected by Firebase App Hosting.
export const firebaseConfigs: Record<EnvironmentKey, FirebaseEnvironmentConfig> = {
  dev: {
    apiKey: 'AIzaSyBdXsPyCq4DM5SzbjSj8ZjnzvFSrlJaULY',
    authDomain: 'dev-danceup.firebaseapp.com',
    projectId: 'dev-danceup',
    storageBucket: 'dev-danceup.firebasestorage.app',
    messagingSenderId: '988466211229',
    appId: '1:988466211229:web:1ecfece677c47257bee774',
    measurementId: 'G-QEZHPCY41P',
    firestoreDatabaseId: 'development',
    appCheckSiteKey: '', // App Check skipped in dev when key is empty
  },
  // Staging and production are populated at build time — do not edit these placeholders.
  staging: {
    apiKey: 'REPLACE_AT_BUILD_TIME',
    authDomain: 'staging-danceup.firebaseapp.com',
    projectId: 'staging-danceup',
    storageBucket: 'staging-danceup.firebasestorage.app',
    messagingSenderId: 'REPLACE_AT_BUILD_TIME',
    appId: 'REPLACE_AT_BUILD_TIME',
    measurementId: 'REPLACE_AT_BUILD_TIME',
    firestoreDatabaseId: 'staging',
    appCheckSiteKey: '6LdsBCktAAAAAK2H7IrH6OZNC8E5zGB7ypzH5FEh',
  },
  production: {
    apiKey: 'REPLACE_AT_BUILD_TIME',
    authDomain: 'production-danceup.firebaseapp.com',
    projectId: 'production-danceup',
    storageBucket: 'production-danceup.firebasestorage.app',
    messagingSenderId: 'REPLACE_AT_BUILD_TIME',
    appId: 'REPLACE_AT_BUILD_TIME',
    measurementId: 'REPLACE_AT_BUILD_TIME',
    firestoreDatabaseId: 'production',
    appCheckSiteKey: '6LfqBiktAAAAADILmqfQ_XbqbShdzZ8i3tSSSbKA',
  },
};
